module.exports = __webpack_public_path__ + "9374cc2926c2948d6fe65b95045fccca.svg";